import * as React from "react";
import { AppBar, Box, Container, Typography, IconButton } from "@mui/material";

import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";

import "./index.css";

const contactData = [
  {
    Icon: PhoneIcon,
    text: "+61 449 609 681",
    href: "tel:+61449609681",
    label: "Call us",
  },
  {
    Icon: EmailIcon,
    text: "info@aspiretaxbook.com.au",
    href: "mailto:info@aspiretaxbook.com.au",
    label: "Email us",
  },
  // {
  //   Icon: LocationOnIcon,
  //   text: "12 Klandy Drive Kalkallo, VIC, 3064, Australia.",
  //   href: null,
  //   label: "Visit us",
  // },
];

const ContactItems = React.memo(() => (
  <Box
    component="address"
    className="top-header-sub_box"
    sx={{ fontStyle: "normal" }}
  >
    {contactData.map(({ Icon, text, href, label }, index) => (
      <Box key={index} className="contact-item-box">
        <Icon className="contact-item-icon" />
        {href ? (
          <Typography
            component="a"
            href={href}
            className="contact-item-text"
            aria-label={label}
          >
            {text}
          </Typography>
        ) : (
          <Typography variant="body2" className="contact-item-text">
            {text}
          </Typography>
        )}
      </Box>
    ))}
  </Box>
));

const socialLinks = [
  { Icon: FacebookIcon, href: "https://facebook.com", label: "Facebook" },
  { Icon: TwitterIcon, href: "https://twitter.com", label: "Twitter" },
  { Icon: InstagramIcon, href: "https://instagram.com", label: "Instagram" },
  { Icon: LinkedInIcon, href: "https://linkedin.com", label: "LinkedIn" },
];

const SocialIcons = React.memo(() => (
  <Box
    component="nav"
    className="social-icons-box"
    aria-label="Social media links"
  >
    {socialLinks.map(({ Icon, href, label }, index) => (
      <IconButton
        key={index}
        size="small"
        className="social-icons-icon__button"
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
      >
        <Icon fontSize="small" />
      </IconButton>
    ))}
  </Box>
));

const TopHeader = () => (
  <Box component="header" sx={{ position: "relative" }}>
    <AppBar position="sticky" className="top-header">
      <Container maxWidth="xl" sx={{ height: "100%" }}>
        <Box className="top-header-main_box">
          <ContactItems />
          <SocialIcons />
        </Box>
      </Container>
    </AppBar>
  </Box>
);

export default React.memo(TopHeader);
